<template>
  <div class="receipt-list">
    <!-- 搜索 -->
    <div class="search">
      <el-form :model="exportForm" ref="exportForm" class="demo-ruleForm">
        <div class="form-row">
          <el-form-item prop="warehouseId" label="仓库名称：">
            <el-select v-model="exportForm.warehouseId" placeholder="请选择仓库" @change="changeWarehouse">
              <el-option v-for="item in warehouseList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="projectName" label="项目名称：">
            <el-select v-model="exportForm.projectName" placeholder="请选择项目">
              <el-option v-for="item in projectList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="date" label="导入日期：">
            <el-date-picker
              v-model="exportForm.date"
              type="month"
              value-format="yyyy-MM"
              placeholder="选择月份"
            ></el-date-picker>
          </el-form-item>
        </div>
        <div class="form-row">
          <el-form-item prop="systemOrderNo" label="系统单号：">
            <el-input
              v-model="exportForm.systemOrderNo"
              placeholder="请输入系统单号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" class="btn-blue" @click="searchData">搜索</el-button>
            <el-button icon="el-icon-refresh" class="btn-gray" @click="reset">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <div class="title-container">
      <p class="table-title">订单取消列表</p>
      <div class="import-export">
        <div class="upload-btn" @click="openUpload">
          <span class="upload-btn-img"></span>
          <span>订单导入</span>
        </div>
      </div>
    </div>

    <!-- 表格 -->
    <div class="table">
      <el-table
       :data="tableData" 
       style="width: 100%">
        <el-table-column 
          v-for="(item, index) in tableTitle" 
          :key="index" 
          :prop="item.prop" 
          :label="item.label"
          :min-width="item.width" 
          show-overflow-tooltip>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <pagination-tpl :total="total" :currentPage="currentPage" :pageSize="pageSize"
          @queryChange="queryChange"></pagination-tpl>
      </div>
    </div>


    <!-- 订单导入 -->
    <el-drawer title="订单导入" :visible.sync="drawer" :wrapperClosable="false" :before-close="handleCloseDrawer">
      <el-form class="entry-form" ref="entryForm" :model="entryForm" :rules="rules">
        <div class="tips">
          <img class="sign-blue" src="~assets/images/sigh/sigh-blue.png">
          <span class="tips-content">完成取消订单的导入，完成数据补充</span>
          <span class="tips-text">（功能介绍）</span>
        </div>
        <el-form-item label="日期" prop="date">
          <el-date-picker
            v-model="entryForm.date"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择月份"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="仓库名称" prop="warehouseId">
          <el-select class="white" clearable v-model="entryForm.warehouseId" placeholder="请选择仓库名称">
            <el-option v-for="item in warehouseList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="下载导入模板">
          <div class="download-tmp" @click="downTmp">
            订单取消导入模板.xlsx
            <img class="upload-bottom" src="~assets/images/upload/upload-bottom.png">
          </div>
        </el-form-item>
        <el-form-item label="订单取消导入">
          <el-input v-if="!uploadFileName" v-model="uploadFileName" placeholder="请上传文件" disabled>
            <template slot="suffix">
              <el-upload v-loading.fullscreen.lock="loading" element-loading-text="文件上传中"
                element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" class="upload"
                ref="upload" action="#" :show-file-list="false" :auto-upload="true"
                :before-upload="uploadWarehouseLocationExcel">
                <img class="upload-img" src="~assets/images/home/upload.png">
              </el-upload>
            </template>
          </el-input>
          <div v-else class="show-name">
            <span>{{ uploadFileName }}</span>
            <img @click="clearUploadFileName" src="~assets/images/close.png">
          </div>
        </el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseDrawer">取消</el-button>
        <el-button class="btn-blue" @click="confirm('entryForm')">确定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import OrderCancel from "models/production/order-cancel.js";
import warehouseMixins from "@/common/mixins/warehouse.js"
import projectMixins from "@/common/mixins/project.js"
import PaginationTpl from "components/base/PaginationTpl";
import { downLoadFile } from "common/js/util";
export default {
  mixins: [warehouseMixins, projectMixins],
  components: {
    PaginationTpl,
  },

  data() {
    return {
      exportForm: {
        warehouseId: '',
        date: "",
        projectName: '',
        systemOrderNo: ''
      },
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitle: [
        { label: '导入日期', prop: 'month', width: '' },
        { label: '仓库名称', prop: 'warehouseName', width: ''},
        { label: '项目名称', prop: 'projectName', width: '' },
        { label: '仓库接单时间', prop: 'warehouseOrderTime', width: '120'},
        { label: '系统单号', prop: 'systemOrderNo', width: ''},
        { label: '外部订单号', prop: 'externalOrderNo', width: ''},
        { label: '线上订单号', prop: 'onlineOrderNo', width: ''},
        { label: '验货员', prop: 'inspector', width: ''},
      ],
      drawer: false,
      entryForm: {
        warehouseId: '',
        date: ''
      },
      rules: {
        warehouseId: [
          { required: true, message: '请选择仓库名称', trigger: 'change' }
        ],
        date: [
          { required: true, message: '请选择月份', trigger: 'change' }
        ]
      },
      loading: false,
      uploadFileName: '',
      /* 订单导入的流 */
      formData: null,
      /* 是否导入 */
      isUpload: true,
    }
  },

  created() {
    this.initWarehouse()
    this.initOrderCancelList()
  },

  methods: {
    /**
     * @desc 订单取消列表
     */
    initOrderCancelList() {
      let warehouseId = this.exportForm.warehouseId
      let billMonth = this.exportForm.date
      let projectId = this.exportForm.projectName
      let systemOrderNo = this.exportForm.systemOrderNo
      let page = this.currentPage
      let data = {
        warehouseId,
        billMonth,
        projectId,
        systemOrderNo,
        page,
      }
      OrderCancel.getOrderCancelList(data).then((res) => {
        if (res.success) {
          let arr = [];
          this.total = res.result.totalNum
          res.result.items.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.warehouseName = value.warehouseName;
            obj.projectName = value.projectName;
            obj.month = value.billMonth;
            obj.warehouseOrderTime = value.warehouseOrderTime;
            obj.systemOrderNo = value.systemOrderNo;
            obj.externalOrderNo = value.externalOrderNo;
            obj.onlineOrderNo = value.onlineOrderNo;
            obj.inspector = value.inspector;
            arr.push(obj);
          });
          this.tableData = arr;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    searchData() {
      this.currentPage = 1;
      this.initOrderCancelList();
    },

    /**
     * @desc 重置搜索内容
    */
    reset() {
      this.exportForm.date = ""
      this.exportForm.warehouseId = ""
      this.exportForm.projectName = ""
      this.exportForm.systemOrderNo = ""
    },

    changeWarehouse() {
      let warehouseId = this.exportForm.warehouseId;
      this.initProjectListByWarehouse(warehouseId);
    },

    /** 
     * @desc 翻页
    */
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initOrderCancelList();
    },

    /** 
     * @desc 开启导入
    */
    openUpload() {
      this.drawer = true
    },

    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let warehouseId = this.entryForm.warehouseId
          let billMonth = this.entryForm.date

          if (this.isUpload) {
            return this.$message.error("请导入文件");
          }
          let formData = this.formData
          if (formData.get('warehouseId')) {
            formData.delete('warehouseId')
          }
          if (formData.get('billMonth')) {
            formData.delete('billMonth')
          }
          formData.append("warehouseId", warehouseId);
          formData.append("billMonth", billMonth);

          OrderCancel
            .postUploadOrderCancel(formData)
            .then(res => {
              if (res.success) {
                this.$message.success("导入成功");
                this.searchData()
                this.handleCloseDrawer()
              } else {
                this.$confirm(res.message, "提示", {
                  showCancelButton: false,
                  confirmButtonText: "确定",
                  type: "warning"
                }).then(() => { });
              }
            })
            .catch(res => {
              console.log(res);
              this.$message.error("导入失败");
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    handleCloseDrawer() {
      this.entryForm.warehouseId = ''
      this.entryForm.date = ''
      this.removeUploadOrder()
      this.drawer = false
    },

    removeUploadOrder() {
      this.formData = null
      this.isUpload = true
      this.uploadFileName = ''
    },

    downTmp() {
      let fileName = '订单取消导入模板'
      let url = 'https://xinge-kz.oss-cn-hangzhou.aliyuncs.com/oa/template/%E5%A2%9E%E5%80%BC%E6%9C%8D%E5%8A%A1%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx'
      downLoadFile(fileName, url)
    },

    //导入Excel表格
    uploadWarehouseLocationExcel(file) {
      this.loading = true
      var formData = new FormData();
      formData.append("file", file);
      this.formData = formData
      this.uploadFileName = file.name
      this.isUpload = false
      if (file) {
        this.loading = false
      }
      return false;
    },


    /**
     * @desc 删除上传文件
     */
    clearUploadFileName() {
      this.uploadFileName = ''
      let formData = this.formData
      this.isUpload = true
      if (formData.get('file')) {
        formData.delete('file')
      }
    },
  }
}
</script>

<style lang='scss'>
@import "@/assets/style/layout/production/receipt-list.scss";
</style>